<div class="header-class">
    <h6>Lignes de livraison : {{ bcLineFormArray ? bcLineFormArray.controls.length - 1 : ''}} 
    Montant HT restant enveloppe : {{ firsLineForm?.get('htRestant').value ? (firsLineForm?.get('htRestant').value | currency:'EUR':'symbol':'1.2-2':'fr') : "0" | currency:'EUR':'symbol':'1.2-2':'fr'}}</h6>
    <button color="success" mat-raised-button type="button" (click)="addLiv()" [disabled]="BCEExpired">
        <mat-icon>add_box</mat-icon>&nbsp;Ajouter une ligne livraison enveloppe
    </button>
</div>
<div class="mat-table">
    <div *ngIf="form">
        <form [formGroup]="form" >
            <div class="table_principal">
                <table #table mat-table [dataSource]="matDataSourceBCLigne" formArrayName="bcLines">
                    <caption>Liste des Bcs lignes</caption>
                    <ng-container matColumnDef="select" *ngIf="!modeRead">
                        <th mat-header-cell *matHeaderCellDef class="align-cell" matTooltip="Livrée">
                            <mat-checkbox *ngIf="!delivrerAll" (change)=" masterToggle()"
                                [checked]="selection.hasValue() && isAllSelected()"
                                [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                            </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row;let index = index" [formGroupName]="index" class="align-cell">
                            <mat-checkbox *ngIf="row.get('fLivre').value!==2 && !row.get('bAnnule').value && (row.get('qteLivre').value + row.get('qteAnnule').value !== row.get('qte').value) "
                                (change)="change(row)" [checked]="selection.isSelected(row)"
                                [disabled]="selectionAnnule.isSelected(row)" [aria-label]="checkboxLabel(row)">
                            </mat-checkbox>
                            <mat-icon class="align-icon green" *ngIf="row.get('fLivre').value === 2">check_circle</mat-icon>
                            <mat-icon class="align-icon grey" *ngIf="row.get('fLivre').value === 1 && (row.get('qteLivre').value + row.get('qteAnnule').value === row.get('qte').value) && !row.get('bAnnule').value">check_circle</mat-icon>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="solder" >
                        <th mat-header-cell *matHeaderCellDef class="align-cell">
                            Soldée
                        </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index" class="align-cell">
                            <mat-checkbox *ngIf="element.get('qteRestant').value > 0 && !element.get('bAnnule').value && element.get('qte').value - element.get('qteLivre').value > 0 && !modeRead"
                            (click)="onClickSolder($event, element)"
                            matTooltip="Solder la ligne" matTooltipClass="error-tooltip">
                        </mat-checkbox>
                            <mat-icon class="align-icon green" *ngIf="element.get('qteRestant').value === 0 && element.get('qte').value > element.get('qteLivre').value" 
                                matTooltip="Ligne soldée" matTooltipClass="error-tooltip">check_circle</mat-icon> 
                        </td>   
                    </ng-container>
                    <ng-container matColumnDef="select" *ngIf="modeRead">
                        <th mat-header-cell *matHeaderCellDef  matTooltip="Livrée"> L </th>
                        <td mat-cell *matCellDef="let element;let index = index" class="align-cell">
                            <mat-icon class="align-icon green" *ngIf="element.get('fLivre').value === 2">check_circle</mat-icon>
                            <mat-icon class="align-icon grey" *ngIf="element.get('fLivre').value === 1 && (element.get('qteLivre').value + element.get('qteAnnule').value === element.get('qte').value) && !element.get('bAnnule').value">check_circle</mat-icon>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="annule" *ngIf="!modeRead">
                        <th mat-header-cell *matHeaderCellDef matTooltip="Annulée"> A </th>
                        <td mat-cell *matCellDef="let row;let index = index" [formGroupName]="index" class="align-cell">
                            <mat-checkbox *ngIf="!row.get('bAnnule').value && row.get('fDeprovis').value !== 2 && row.get('id').value != 0"
                                onclick="event.stopPropagation()"
                                (change)="changeAnnule(row)"
                                [checked]="selectionAnnule.isSelected(row)"
                                [aria-label]="checkboxLabel(row)" 
                                [disabled]="selection.isSelected(row)">
                            </mat-checkbox>
                            <mat-icon class="align-icon red" *ngIf="row.get('bAnnule').value">cancel</mat-icon>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="annule" matTooltip="Annulée" *ngIf="modeRead">
                        <th mat-header-cell *matHeaderCellDef> A </th>
                        <td mat-cell *matCellDef="let element;let index = index" class="align-cell">
                            <mat-icon class="align-icon red" *ngIf="element.get('bAnnule').value  === true">cancel</mat-icon>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="article">
                        <th mat-header-cell *matHeaderCellDef> Article </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            [matTooltip]="element.get('libelleArticle').value">
                            {{element.get('codeArticle').value}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="libelle">
                        <th mat-header-cell *matHeaderCellDef> Désignation </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index">
                            <div class="with-padding-left">
                                {{element.get('libelle').value}}
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="qte">
                        <th mat-header-cell *matHeaderCellDef> Qte commandée </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index">
                            <div class="with-padding-right">
                                {{element.get('qte').value | number:'1.0-4' :'fr'}}
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="qteLiv">
                        <th mat-header-cell *matHeaderCellDef> Qte Livrée </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            class="allign-right">
                            <div class="with-padding-right">
                                {{element.get('qteLivre').value | number:'1.0-4' :'fr'}}
                            </div>
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="livraisonsBc">
                        <th mat-header-cell *matHeaderCellDef style="width: 8vw;"> Dates Livraison</th>
                        <td mat-cell *matCellDef="let element; let index= index" [formGroupName]="index" class="centrer">
                            <ul class="livraisons" formArrayName="livraisonsBc">
                                <mat-form-field style="padding-left: 2px; padding-right: 2px;" *ngFor="let el of element.get('livraisonsBc').controls; index as i;"
                                    [formGroupName]="i" class="no-bottom-padding full-width">
                                    <input required class="fix-input-position" matInput [value]="getMaxDate()"
                                        [matDatepicker]="pickerDLivr" formControlName="dLivraison" />
                                    <mat-datepicker-toggle class="fix-input-position" matSuffix [for]="pickerDLivr"></mat-datepicker-toggle>
                                    <mat-datepicker class="fix-input-position" #pickerDLivr></mat-datepicker>
                                </mat-form-field>
                            </ul>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="qteLitige">
                        <th mat-header-cell *matHeaderCellDef> Montant HT Litigé </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            class="allign-right" onclick="event.stopPropagation()">
                            <ul class="livraisons" formArrayName="livraisonsBc">
                                <mat-form-field class="no-bottom-padding full-width" style="padding-left: 2px; padding-right: 2px;"
                                    *ngFor="let el of element.get('livraisonsBc').controls; index as i;"
                                    [formGroupName]="i">
                                    <input matInput class="fix-input-position" type="number" maxlength="30" placeholder="MNT"
                                        matTooltip="La quantité ne peut pas être vide" matTooltipClass="error-tooltip"
                                        [matTooltipShowDelay]="showDelay.value" [matTooltipHideDelay]="hideDelay.value"
                                        formControlName="qteLitige">
                                </mat-form-field>
                            </ul>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="pu" >
                        <th mat-header-cell *matHeaderCellDef matTooltip="Prix unitaire"> PU </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            class="allign-right">
                            <div class="with-padding-right">
                                {{element.get('pu').value | currency:'EUR':'symbol':'1.2-2':'fr'}}
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="tva">
                        <th mat-header-cell *matHeaderCellDef> TVA </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index" class="centrer">
                            {{element.get('codeTva').value}}-
                            {{element.get('libelleTva').value}}-
                            {{element.get('tauxTva').value }}%
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="naCode" matTooltip="Nature analytique">
                        <th mat-header-cell *matHeaderCellDef> NA </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            [matTooltip]="element.get('libelleNa').value" class="centrer">
                            {{element.get('codeNa').value}} 
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="cg" matTooltip="Compte général de charge">
                        <th mat-header-cell *matHeaderCellDef> CG Charge </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            [matTooltip]="element.get('libelleCgCharge').value" class="centrer">
                            {{element.get('codeCgCharge').value}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="ca1">
                        <th mat-header-cell *matHeaderCellDef matTooltip="Centre analytique 1">CA1 </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            [matTooltip]="element.get('libelleCa1').value" class="centrer">
                            {{element.get('codeCa1').value}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="ca2">
                        <th mat-header-cell *matHeaderCellDef  matTooltip="Centre analytique 2"> CA2 </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            [matTooltip]="element.get('libelleCa2').value" class="centrer">
                            {{element.get('codeCa2').value}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="complement">
                        <th mat-header-cell *matHeaderCellDef> Complément </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            [matTooltip]="element.get('libelleComp').value" class="centrer">
                            {{element.get('codeComp').value}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="equipement">
                        <th mat-header-cell *matHeaderCellDef> Équipement </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index" class="centrer"> 
                            {{element.get('vehicule').value}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="codeAe">
                        <th mat-header-cell *matHeaderCellDef> Chantier </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index" class="centrer">
                            {{element.get('chantier').value}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="mntHt">
                        <th mat-header-cell *matHeaderCellDef matTooltip="Prix hors taxe"> Montant HT</th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index" class="allign-right">
                            <div class="with-padding-right">
                                {{element.get('ht').value| currency:'EUR':'symbol':'1.2-2':'fr'}}
                            </div>
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="htLiv">
                        <th mat-header-cell *matHeaderCellDef  matTooltip="Prix hors taxe livré"> HT Livré</th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index" class="allign-right">
                            <ul class="livraisons" formArrayName="livraisonsBc">
                                <mat-form-field class="no-bottom-padding full-width" style="padding-left: 2px; padding-right: 2px;"
                                    *ngFor="let el of element.get('livraisonsBc').controls; index as i;"
                                    [formGroupName]="i">
                                    <input matInput class="fix-input-position" [value]="el.controls['htLivre'].value | currency:'EUR':'symbol':'1.2-2':'fr'" disabled>
                                </mat-form-field>
                            </ul>
                        </td>
                    </ng-container>
                    
                    <ng-container matColumnDef="bp">
                        <th mat-header-cell *matHeaderCellDef> Facture </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            class="align-cell">
                            <div *ngIf="element.get('fHasBp')">
                                <mat-icon class="align-icon green" *ngIf="element.get('fHasBp').value === 2">check_circle</mat-icon>
                                <mat-icon class="align-icon grey" *ngIf="element.get('fHasBp').value === 1">check_circle</mat-icon>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="qteRestant">
                        <th mat-header-cell *matHeaderCellDef matTooltip="Quantité commandé en attente de livraison"> Qte Restant</th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index" class="allign-right">
                            <div class="with-padding-right">
                                {{element.get('qteRestant').value |  number : '1.0-4'}}
                            </div>                        
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="f">
                        <th mat-header-cell *matHeaderCellDef matTooltip="Facturée"> F </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            class="align-cell">
                            <div *ngIf="element.get('fFacture')">
                                <mat-icon class="align-icon green" *ngIf="element.get('fFacture').value">check_circle</mat-icon>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="p">
                        <th mat-header-cell *matHeaderCellDef matTooltip="Provisionée"> P </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            class="align-cell">
                            <div *ngIf="element.get('fProvis')">
                                <mat-icon class="align-icon green" *ngIf="element.get('fProvis').value === 2">check_circle</mat-icon>
                                <mat-icon class="align-icon grey" *ngIf="element.get('fProvis').value === 1">check_circle</mat-icon>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="d">
                        <th mat-header-cell *matHeaderCellDef matTooltip="Déprovisionée"> D </th>
                        <td mat-cell *matCellDef="let element;let index = index" [formGroupName]="index"
                            class="align-cell">
                            <div *ngIf="element.get('fDeprovis')">
                                <mat-icon class="align-icon green" *ngIf="element.get('fDeprovis').value === 2">check_circle</mat-icon>
                                <mat-icon class="align-icon grey" *ngIf="element.get('fDeprovis').value === 1">check_circle</mat-icon>
                            </div>

                        </td>
                    </ng-container>

                    <!--
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="element-disabled"> Actions </th>
                        <td mat-cell *matCellDef="let element;let i = index" class="centrer">
                            <div *ngIf="i > 0">
                                <span matTooltip="Dupliquer cette ligne">
                                    <mat-icon (click)="$event.stopPropagation(); duplicateRow(element, i); " class="blue-icon">control_point_duplicate</mat-icon> 
                                </span>
                                <span matTooltip="Supprimer cette ligne">
                                    <mat-icon (click)="$event.stopPropagation(); deleteRow(element, i);" class="red-icon">close</mat-icon>
                                </span>
                            </div>
                        </td>
                    </ng-container>
                    -->

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsBC ;sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsBC; let i = index" (click)="openModal(i, row)" [class.hidden]="i === 0"><div *ngIf="i != 0"></div></tr>
                </table>
            </div>
        </form>
    </div>
</div>